/* eslint-disable */
import axios from "axios";
import "../utils/axios.interceptor";
import { format } from "date-fns";
import { urlCoreBack } from "../configs/config";

const epGetAjustesArticulo = "v1/ajuste-articulo/?";
const epNameAjusteArticulo = "v1/ajuste-articulo/";
//
// #############################################################################
//
export const getAjustesArticulo = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener los Ajustes de Artículo";

  if (params) {
    if (params.codigoAjuste) {
      _params.codigo = params.codigoAjuste;
    }

    if (params.descripcion) {
      _params.descripcion = params.descripcion;
    }

    if (params.usuario) {
      _params.id_usuario = params.usuario;
    }

    if (params.idTipoAjusteStock) {
      _params.id_tipo_ajuste_stock = params.idTipoAjusteStock;
    }

    if (params.estadoActual) {
      _params.estado_actual = params.estadoActual;
    }

    if (params.fechaCreacionDesde) {
      _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
    }

    if (params.fechaCreacionHasta) {
      _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
    }

    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }
  }
  _params.id_area = localStorage.getItem("id_area_deposito");

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epGetAjustesArticulo}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.message_code;
    if (_message_code === "err-caja-mdc-os-plan-invalid") {
      response.messageText = `El Plan de Obra Social no es válido`;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getAjusteArticulo = async (parIdAjuste) => {
  let _errorMessage = "Se produjo un error al obtener el Ajuste de artículo";
  let _params = {};
  _params.id = parIdAjuste;
  _params.id_area = localStorage.getItem("id_area_deposito");

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epGetAjustesArticulo}`,
      params: _params
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveAjusteArticulo = async (parAction, parAjusteArticulo) => {

  let _errorMessage = "";

  if (parAction === "new" || parAction === "update") {
    _errorMessage = "No fue posible guardar el Ajuste de Artículos";
  } else {
    _errorMessage = "No fue posible anular el Ajuste de Artículos";
  }
  parAjusteArticulo.id_area = localStorage.getItem("id_area_deposito");
  parAjusteArticulo.id_usuario = localStorage.getItem("id_usuario");

  try {
    let response = {};
    if (parAction === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epNameAjusteArticulo}`,
        data: parAjusteArticulo,
      });
    } else if (parAction === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epNameAjusteArticulo}`,
        data: parAjusteArticulo,
      });
    } else {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epNameAjusteArticulo}`,
        params: parAjusteArticulo,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `Ajuste de Artículos ${["new", "update"].includes(parAction) ? "guardado" : "anulado"}`;
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-ajuste-articulo-cantidad-disponible-insuficiente") {
        response.ok = false;
        response.messageText = "Cantidad de artículo insuficiente"
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-ajuste-articulo-delete-not-allowed") {
        // En caso de error busco marca y modelo de producto y lo muestro en el mensaje
        response.ok = false;
        response.messageText = "No fue opsible anular el Ajuste de Artículos";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-ajuste-articulo-modify-not-allowed") {
        // En caso de error busco marca y modelo de producto y lo muestro en el mensaje
        response.ok = false;
        response.messageText = "No fue opsible modificar el Ajuste de Artículos";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};